import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DataService } from "src/app/shared/services/data.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root',
})
export class SitePrepService extends DataService<any> {

  httpClient: HttpClient;

  constructor(http: HttpClient) {
    super(`${environment.apiUrl.deviceMgmtService}siteprep`, http);
    this.httpClient = http;
  }

  createSitePreparationScript(): Observable<any> {
    return this.http.post<any>(this.url, {},
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      });
  }
}